import DashboardSrv from './DashboardSrv';
import actionTypes from './actionTypes';

export function getData() {
  return function(dispatch) {
    return DashboardSrv.get().then(results => {
      dispatch({
        type: actionTypes.STORE_DASHBOARD_DATA,
        data: results,
      });
    });
  };
}

export function getDiagram() {
  return function(dispatch) {
    return DashboardSrv.getDiagram().then(result => {
      dispatch({
        type: actionTypes.STORE_DASHBOARD_DIAGRAM,
        data: result,
      });
    });
  };
}
